import {
    GET_TEACHERS_FAIL,
    GET_TEACHERS_SUCCESS,
    ADD_TEACHER_SUCCESS,
    ADD_TEACHER_FAIL,
    UPDATE_TEACHER_SUCCESS,
    UPDATE_TEACHER_FAIL,
    DELETE_TEACHER_SUCCESS,
    DELETE_TEACHER_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    teachers: [],
    error: null,
    loading: true
};

const teacherReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des teachers
        case GET_TEACHERS_SUCCESS:
            return {
                ...state,
                teachers: action.payload, // tableau d'objets teacher
                loading: false,
                error: null
            };

        case GET_TEACHERS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une teachere
        case ADD_TEACHER_SUCCESS:
            return {
                ...state,
                teachers: [action.payload, ...state.teachers], // ajoute au début du tableau
                error: null
            };

        case ADD_TEACHER_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une teachere
        case UPDATE_TEACHER_SUCCESS:
            return {
                ...state,
                teachers: state.teachers.map(teacher =>
                    teacher.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet teacher
                        : teacher
                ),
                error: null
            };

        case UPDATE_TEACHER_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une teachere
        case DELETE_TEACHER_SUCCESS:
            return {
                ...state,
                teachers: state.teachers.filter(
                    teacher => teacher.id !== action.payload
                ),
                error: null
            };


        case DELETE_TEACHER_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default teacherReducer;
